import script from "./RecommendedVendor.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendedVendor.vue?vue&type=script&setup=true&lang=js"

import "./RecommendedVendor.vue?vue&type=style&index=0&id=a6e8700a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6e8700a"]])

export default __exports__